export default __webpack_public_path__ + "static/media/how-it-works--desktop.3e41ddfc.webp";